import { withPropsOnChange } from 'recompose';
import { isFunction } from 'lodash';

const MAX_VALUE = 100000000;
const propValue = (props, key) => (isFunction(key) ? key(props) : key);
const limitValue = (max = MAX_VALUE, value = 'value', setValue = 'setValue') => withPropsOnChange(
  (props, nextProps) => (props[propValue(props, value)] !== nextProps[propValue(nextProps, value)]),
  (props) => {
    const maxValue = propValue(props, max);
    const valueKey = propValue(props, value);
    const setValueKey = propValue(props, setValue);
    if (props[valueKey] > maxValue) setTimeout(() => props[setValueKey](maxValue));
  }
);

export default limitValue;
